import { TextField } from '@mui/material'

function ValidatedTextfield(props: any) {
  return (
    <TextField
      {...props}
      variant="outlined"
      sx={{
        ...props.sx,
        '& input[valid=true] + fieldset': {
          borderColor: 'lawngreen',
          borderWidth: 3,
        },
        '& input[valid=false] + fieldset': {
          borderColor: 'red',
          borderWidth: 3,
        },
      }}
    />
  )
}

export default ValidatedTextfield
